export const translations = {
    ar: {
        blog: {
            title: 'المدونة القانونية',
            subtitle: 'أحدث المقالات والتحليلات القانونية',
            readMore: 'اقرأ المزيد',
            posts: [
                {
                    id: 1,
                    title: 'القانون التجاري والشركات',
                    summary: 'نظرة عامة على أحدث التطورات في قانون الشركات والتجارة',
        date: '2025/01/15',
                },
                {
                    id: 2,
                    title: 'قانون العمل والتوظيف',
                    summary: 'تحليل لأهم التغييرات في قوانين العمل والتوظيف',
        date: '2025/01/15',
                },
                {
                    id: 3,
                    title: 'الملكية الفكرية',
                    summary: 'دليل شامل لحماية حقوق الملكية الفكرية في العصر الرقمي',
        date: '2025/01/15',
                }
            ]
        }
    },
    en: {
        blog: {
            title: 'Legal Blog',
            subtitle: 'Latest Legal Articles and Analysis',
            readMore: 'Read More',
            posts: [
                {
                    id: 1,
                    title: 'Commercial and Corporate Law',
                    summary: 'Overview of latest developments in corporate and commercial law',
        date: '2025/01/15',
                },
                {
                    id: 2,
                    title: 'Labor and Employment Law',
                    summary: 'Analysis of important changes in labor and employment laws',
        date: '2025/01/15',
                },
                {
                    id: 3,
                    title: 'Intellectual Property',
                    summary: 'Comprehensive guide to protecting intellectual property in the digital age',
        date: '2025/01/15',
                }
            ]
        }
    }
};